type ThemeStyle = Record<string, string>;

const COLOR_TOKEN = /^(#|rgb|hsl|var\()/i;

export function isColorToken(value: string): boolean {
  return COLOR_TOKEN.test(value.trim());
}

export function resolveThemeToken(
  value: string | null | undefined,
  cssProperty: keyof ThemeStyle
): { className: string; style: ThemeStyle } {
  if (!value) return { className: '', style: {} };
  const trimmed = value.trim();
  if (!trimmed) return { className: '', style: {} };
  if (isColorToken(trimmed)) {
    return { className: '', style: { [cssProperty]: trimmed } };
  }
  return { className: trimmed, style: {} };
}
